import { API_URL } from "@/constants/envVariables";

export const authLogin = async (
  email: string,
  password: string,
  recaptchaToken: string,
  headers: Record<string, string>,
): Promise<{ token?: string; message?: string }> => {
  const response = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify({
      email,
      password,
      recaptcha_token: recaptchaToken,
    }),
  });

  let responseJson: { error?: string; extras?: Record<string, unknown>; token?: string };
  try {
    responseJson = await response.json();
  } catch {
    throw { error: `Request failed with status ${response.status}` };
  }

  if (!response.ok) {
    const err = responseJson as { error?: string; extras?: Record<string, unknown> };
    (err as { status?: number }).status = response.status;
    throw err;
  }

  if (responseJson.error) {
    throw responseJson;
  }

  return responseJson as { token?: string; message?: string };
};
